// extracted by mini-css-extract-plugin
export default {"icon_button":"NtfRuleActionCell_icon_button__Eqain","row_modal":"NtfRuleActionCell_row_modal__JtShN"};